<span>{{params.value}}</span>
<button mat-icon-button (click)="addItem(params);$event.stopPropagation()">
  <mat-icon title="Add alarm">
    add_circle
  </mat-icon>
</button>
